export default __webpack_public_path__ + "static/media/play-icon.f7bb30d6.png";